<template>
  <div>
    <div class="flex flex-wrap flex-col bg-white rounded-lg border overflow-auto border-gray-200 shadow-md dark:bg-gray-800 dark:border-gray-700">
      <div class="flex flex-wrap flex-col mt-2 mb-2">
        <div>
          <v-progress-linear
            v-if="loading"
            color="blue lighten-2"
            height="20"
            :value="100"
            striped
            class="animate"
          ></v-progress-linear>
         </div>
        <div v-if="imageUrl !== '' && processedImage.processedImageUrl === ''">
          <div class="flex flex-wrap justify-center mb-1">
            <img :src="imageUrl" style="object-contain h-48 w-96"/>
          </div>
        </div>
        <div v-if="processedImage.processedImageUrl !== ''" class="flex flex-wrap flex-row">
          <div class="md:h-full md:w-2/3">
            <div class="mb-1 flex flex-row p-1 justify-center">
              <button @click="selectTab('original')" type="button" class="font-bold rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center mr-2 dark:bg-blue-600" :class="processedImage.isOriginalTab === true ? 'text-white bg-blue-700' : 'text-blue-700 bg-white'">
                Original
              </button>

              <button @click="selectTab('removed_background')" type="button" class="font-bold rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center mr-2 dark:bg-blue-600 " :class="processedImage.isOriginalTab === false ? 'text-white bg-blue-700' : 'text-blue-700 bg-white'">
                Removed Background
              </button>
            </div>
            <div class="flex justify-center mb-1">
              <img :hidden="!processedImage.isOriginalTab" :src="processedImage.baseImageUrl" class="transparent object-contain h-64 w-96" />
              <img :hidden="processedImage.isOriginalTab" :src="processedImage.processedImageUrl" class="transparent object-contain h-64 w-96" />
            </div>
          </div>
          <div v-if="processedImage.processedImageUrl !== ''" class="md:h-full md:w-1/3 m-auto">
            <div class="flex flex-wrap flex-col justify-center md:mt-6 mb-2 p-2">
                <div class="mb-1">
                  <a :href="processedImage.processedImageUrl" @click="downloadTracker(0)" :download="processedImage.processedImageFileName" target="_blank">
                    <v-btn class="mb-1"><v-icon>mdi-download</v-icon><b>Download</b></v-btn>
                  </a>
                </div>
                <div class="mb-1">
                  <span class="block text-xs">Preview size (eg: 625x400 pixels)</span>
                </div>
                <div v-if="processedImage.processedImageUrlOriginal === ''" class="mb-1">
                  <v-btn class="primary" @click="openCreditNeedDialog"><v-icon>mdi-download</v-icon><b>Download HD</b></v-btn>
                </div>
                
                <div v-else class="mb-1">
                  <a :href="processedImage.processedImageUrlOriginal" @click="downloadTracker(1)" :download="processedImage.processedImageFileNameOriginal" target="_blank">
                    <v-btn class="primary"><v-icon>mdi-download</v-icon><b>Now Download HD</b></v-btn>
                  </a>
                </div>
                <div class="mb-1">
                  <span class="block text-xs">Full size (eg: 6250 x 4000 pixels)</span>
                </div>
            </div>
            <div class="flex flex-wrap flex-row p-2">
              <span class="block text-xs"><i>Please save your image because we will keep it only <b>2 hours</b>.</i></span>
            </div>
            <div class="flex flex-wrap flex-row justify-end">
              <span v-if="processedImage.processedImageUrl !== ''" @click="closeUpload" class="p-2 cursor-pointer text-2xs bg-gray-100 dark:bg-gray-800 dark:border-gray-700">close</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="text-center">
          <v-dialog
            v-model="creditNeedDialog"
            width="500"
          >

            <v-card>
              <v-card-title>
                Need Credit Usage
              </v-card-title>

              <v-card-text>
                <v-row justify="center" align="center">
                  <v-col cols="12" v-if="processedImage.processedImageUrlOriginal === ''">
                    <v-img :src="processedImage.processedImageUrl" style="border: 1px solid #ccc;" width="300" class="img-fluid transparent" />
                  </v-col>
                  <v-col cols="12" v-else>
                    <a :href="processedImage.processedImageUrlOriginal" :download="processedImage.processedImageFileNameOriginal" target="_blank">
                      <v-img :src="processedImage.processedImageUrl" style="border: 1px solid #ccc;" width="300" class="img-fluid transparent" />
                    </a>
                  </v-col>
                  <v-col v-if="errorMessage === ''">
                    <span>In order to download the image that has been <b>Background Removed</b>, you need to use <b>1 credit.</b>
                    Do you accept?</span>
                  </v-col>
                </v-row>
                
                <v-row v-if="errorMessage !== ''">
                  <v-col>
                    <span class="text-sm font-bold text-gray-900 dark:text-gray-400">We could not succeed the process since</span>
                    <br>
                    <span class="text-sm font-medium text-red-700 dark:text-red-200"><strong>{{errorMessage}}</strong></span>
                  </v-col>
                </v-row>

                <v-row v-if="error">
                  <v-col>
                    {{ error.code }}
                    <span class="text-sm font-medium text-green-700 dark:text-green-200">Do you need some credits? <v-btn
                    color="primary"
                    class="ma-1"
                    @click="goToPricing"
                  >
                    Go To Pricing
                  </v-btn>
                    </span>
                  </v-col>
                </v-row>
              </v-card-text>

              <v-divider></v-divider>

              <v-card-actions v-if="!error">
                <div v-if="processedImage.processedImageUrlOriginal === ''" class="flex flex-wrap justify-end">
                  <v-btn
                    class="ma-1"
                    depressed
                    @click="creditNeedDialog = false"
                  >
                    No
                  </v-btn>
                  <v-btn
                    color="primary"
                    class="ma-1"
                    @click="handleUseCredits"
                  >
                    Yes
                  </v-btn>
                </div>
                <div v-else class="flex flex-wrap justify-center">
                <a :href="processedImage.processedImageUrlOriginal" @click="downloadTracker(1)" :download="processedImage.processedImageFileNameOriginal" target="_blank">
                  <v-btn class="primary"><v-icon>mdi-download</v-icon><b>Now Download HD</b></v-btn>
                </a>
              </div>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </div>

        <div class="text-center">
          <v-dialog
            v-model="creditNeedNewUserDialog"
            width="500"
          >

            <v-card>
              <v-card-title>
                Need Credit Usage For This Action
              </v-card-title>

              <v-card-text>
                In order to download the <b><i>High Quality</i></b> image that has been <b>Background Removed</b> already, you need to use <b>1 credit.</b>
                You can <v-btn small color='primary' @click="login">login</v-btn> and try again.
                <br><br>
                <b>If you don't have an account, you can get 1 CREDIT BONUS</b> when you <v-btn small color='primary' @click="register">sign up</v-btn>
              </v-card-text>
            </v-card>
          </v-dialog>
        </div>
    </div>
</template>

<script>
import ToolService from '../services/tool.service';
import FileService from '../services/file.service';

export default {
  name: "Upload",
  components: {
  },
  props: {
    toRedirect : Boolean,
    index : {
      default: '',
      type: String
    },
    dragFile : {
      default: null,
      type: File,
    },
    selectedFile : {
      default: null,
      type: Event
    },
    loadedImage: {
      default: null,
      type: Object
    }
  },
  data() {
    return {
      dragover: false,
      uploadedFiles: [],
      image: undefined,
      imageUrl: '',
      processedImage:
      {
        processedImageUrlOriginal: '',
        processedImageFileNameOriginal: '',
        processedImageUrl: '',
        processedImageFileName: '',
        baseImageUrl: '',
        baseImageFileName: '',
        originalImageData: {
          id: ''
        },
        isOriginalTab: true
      },
      loading: false,
      isSelecting: false,
      creditNeedDialog: false,
      creditNeedNewUserDialog: false,
      finished: false,
      processing: false,
      show: true,
      errorMessage: '',
      error: null
    };
  },
  computed: {
    loggedIn() {
      return this.$store.state.auth.status.loggedIn;
    }
  },
  created: function () {
    if(!this.finished)
    {
      if(this.loadedImage !== null && this.loadedImage.baseImageFileName !== '')
      {
        this.processedImage = this.loadedImage;
      }else if(this.dragFile !== null)
      {
        this.onDrop(this.dragFile);
      }else if(this.selectedFile !== null)
      {
        this.onImageSelected(this.selectedFile);
      }
    }

    if(this.$route.query.selectedIndex !== undefined)
    {
      if(this.$route.query.selectedIndex === this.index)
      {
        this.openCreditNeedDialog();
      }
    }
  },
  methods: {
    removeFile(fileName) {
      // Find the index of the
      const index = this.uploadedFiles.findIndex(
        file => file.name === fileName
      );
      // If file is in uploaded files remove it
      if (index > -1) this.uploadedFiles.splice(index, 1);
    },
    onDrop(e) {
      this.dragover = false;
      var file = e;

      if(!this.finished)
      {
        // If there are already uploaded files remove them
        if (this.uploadedFiles.length > 0) this.uploadedFiles = [];

        this.imageUrl = "";
        this.processedImage.baseImageUrl = "";
        this.processedImage.processedImageUrl = "";
        this.processedImage.processedImageFileName = ""
        this.uploadedFiles.push(file);
        this.createImage(file);
        this.handleRemoveBackground();
      }
    },
    onImageSelected(event) {
      const files = event.target.files
      const fileReader = new FileReader()
      fileReader.addEventListener('load', () => {
        this.imageUrl = fileReader.result
      })
      fileReader.readAsDataURL(files[0])
      this.image = files[0]

      if (this.uploadedFiles.length > 0) this.uploadedFiles = [];
      
      this.imageUrl = "";
      this.processedImage.baseImageUrl = "";
      this.processedImage.processedImageUrl = "";
      this.processedImage.processedImageFileName = ""
      this.uploadedFiles.push(this.image);
      this.createImage(this.image);
      this.handleRemoveBackground();
    },
    submit() {
      // If there aren't any files to be uploaded throw error
      if (!this.uploadedFiles.length > 0) {
        this.$store.dispatch("addNotification", {
          message: "There are no files to upload",
          colour: "error"
        });
      } else {
        // Send uploaded files to parent component
        //this.$emit("filesUploaded", this.uploadedFiles);

        this.handleRemoveBackground();
      }
    },

    createImage(file) {
      const reader = new FileReader();
      
      reader.onload = (e) => {
        this.imageUrl = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    onFileChange(file) {
      if (!file) {
        return;
      }
      this.createImage(file);
    },

    handleRemoveBackground(){
        this.loading = true;
        ToolService.doRemoveBackground(this.uploadedFiles).then(
          response => {
            this.processDetails = response.data.response;
            this.processedImage.baseImageUrl = this.processDetails.base_image;
            this.processedImage.baseImageFileName = this.processDetails.base_image_name;
            this.processedImage.processedImageUrl = this.processDetails.preview_image;
            this.processedImage.processedImageFileName = this.processDetails.preview_image_name;
            this.processedImage.originalImageData.id = this.processDetails.original_image_id;
            this.loading = false;
            this.finished = true;
            this.processedImage.isOriginalTab = false;
            this.saveImage();
            this.$emit('finished');
          },
          error => {
            this.content =
              (error.response && error.response.data) ||
              error.message ||
              error.toString();
              this.loading = false;
          }
        );
      },

      handleUseCredits(){
        this.loading = true;
        this.errorMessage = '';
        ToolService.useCredits(this.processedImage.originalImageData.id).then(
          response => {
              this.processDetails = response.data.response;
              
              this.processedImage.processedImageUrlOriginal = this.processDetails.original_image;
              this.processedImage.processedImageFileNameOriginal = this.processDetails.original_image_name;

              this.updateImage(this.processedImage);

              this.loading = false;
          },
          error => {
            this.error = error.response;
            this.errorMessage = this.error.data.response.message;

            this.content =
              (error.response && error.response.data) ||
              error.message ||
              error.toString();
              this.loading = false;
          }
        );
      },

      downloadTracker(isOriginal){
        FileService.downloadTracker(this.processedImage, isOriginal).then(
          response => {
            console.log(response);
          },
          error => {
            this.content =
              (error.response && error.response.data) ||
              error.message ||
              error.toString();
              this.loading = false;
          }
        );
      },

      openCreditNeedDialog() {
        if(this.loggedIn)
        {
          this.creditNeedDialog = true;
        }else{
          this.creditNeedNewUserDialog = true;
        }
      },

      login() {
        this.$router.push({
          name: 'LoginPage',
          query: {
            redirect : 'UploadPage',
            index: this.index
            }
          });
      },
      register() {
        this.$router.push('/register');
      },
      
      selectTab(tab) {
        if(tab === 'original')
        {
          this.processedImage.isOriginalTab = true;
        }
        else
        {
          this.processedImage.isOriginalTab = false;
        }
        this.updateImage();
      },

      saveImage() {
        this.$emit('saveImage', this.processedImage);
      },

      updateImage() {
        this.$emit('updateImage', this.processedImage);
      },

      closeUpload() {
        this.$emit('closeUpload', this.processedImage);
      },

      goToPricing() {
        this.$router.push('/pricing');
      },
  }
};
</script>